export function buildPath(...partPath) {
    return partPath.join('/');
}
